import RegistrationBanner from "./RegistrationBanner";

export default RegistrationBanner;
